import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function OrderStatus() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!orderId) { setStatus("failed"); return; }
    const poll = async () => {
      try {
        const { data } = await api.post(`/orders/${orderId}/confirm-payment`, { session_id: sessionId });
        if (data.status === "paid") { setStatus("paid"); return; }
      } catch (e) { /* retry */ }
      tries.current += 1;
      if (tries.current < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [orderId, sessionId]);

  return (
    <div data-testid="order-status-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-primary mx-auto animate-spin" />
            <h1 className="font-display text-3xl mt-6">Confirming payment</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 data-testid="order-paid-icon" className="w-12 h-12 text-emerald-500 mx-auto" />
            <h1 className="font-display text-3xl mt-6">Order confirmed & paid</h1>
            <p className="text-muted-foreground mt-3 text-sm">The kitchen has your order. A confirmation email is on its way.</p>
          </>
        )}
        {(status === "pending" || status === "failed") && (
          <>
            <XCircle className="w-12 h-12 text-amber-400 mx-auto" />
            <h1 className="font-display text-3xl mt-6">Payment not confirmed</h1>
            <p className="text-muted-foreground mt-3 text-sm">If you completed payment, the restaurant will confirm shortly.</p>
          </>
        )}
        <Link to="/restaurants"><Button variant="outline" className="mt-8 rounded-full">Back to restaurants</Button></Link>
      </div>
    </div>
  );
}
